import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { IEngineModel } from '../features/engines/models/EngineModel';

@Injectable({
  providedIn: 'root',
})
export class EngineService {
  constructor(private http: HttpClient) {}

  getEngines() {
    return this.http.get<IEngineModel[]>(`${environment.API_URL}/api/engines`);
  }

  getEnginesByOwner(page: number, limit: number, search?: string) {
    const params: any = { page, limit };
    if (search) {
      params.search = search;
    }
    return this.http.get<{ items: IEngineModel[]; total: number; page: number; limit: number }>(`${environment.API_URL}/api/engines/owner`, { params });
  }


  getEngineById(id: string) {
    return this.http.get(`${environment.API_URL}/api/engines/${id}`);
  }

  createEngine(engine: any) {
    return this.http.post(`${environment.API_URL}/api/engines`, engine);
  }

  vinculateEngineToVessel(engineId: string, vesselId: string) {
    return this.http.post(`${environment.API_URL}/api/engines/vinculate`, { engineId, vesselId });
  }

  desvinculateEngineFromVessel(engineId: string, vesselId: string) {
    return this.http.post(`${environment.API_URL}/api/engines/desvinculate`, { engineId, vesselId });
  }

  updateEngine(id: string, engine: any) {
    return this.http.put<any>(`${environment.API_URL}/api/engines/${id}`, engine);
  }

  deleteEngine(id: string) {
    return this.http.delete(`${environment.API_URL}/api/engines/${id}`);
  }
}
